<template>
    <div class="w-70 mx-auto">
        <div class="table-responsive ms-5 me-5">
            <table class="table">
                <tbody>
                    <tr>
                        <th>Línea</th>
                        <th>Nombre</th>
                        <th>Descripción</th>
                    </tr>
                    <tr v-for="rawMat in rawMaterials" :key="rawMat.id">
                        <td>{{ rawMat.type }}</td>
                        <td>{{ rawMat.name }}</td>
                        <td>{{ rawMat.description }}.</td>
                        <td><button class="btn btn-danger" @click.prevent="editRawMat(rawMat.id)">Editar</button></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <hr style="color: darkred;" class="mx-5">
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    data() {
        return {
            rawMaterials: [],
        };
    },
    beforeMount() {
        axios
            .get(RUTA_SERVIDOR + "api/rawMaterial/list", {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
            .then((res) => {
                console.log(res.data);
                this.rawMaterials = res.data;
                this.cleanRawMat(this.rawMaterials);
            })
            .catch((err) => console.log(`There has been an error ${err}`));
    },
    methods: {
        cleanRawMat(rawMatList) {
            for (let i = 0; i < rawMatList.length; i++) {
                switch (rawMatList[i].type) {
                    case "lam":
                        rawMatList[i].type = "Láminas";
                        break;
                    case "perf":
                        rawMatList[i].type = "Perfiles";
                        break;
                    case "tub":
                        rawMatList[i].type = "Tubos";
                        break;
                    default:
                        rawMatList[i].type = "Tipo no reconocido";
                }
            }
        },
        editRawMat(rawMaterialId) {
            this.$emit("sendRawMaterialId", rawMaterialId);
        }
    }
};
</script>